export default __webpack_public_path__ + "static/media/GAD7.3f3ce4b8.pdf";